var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightchevron(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1513",
    "data-name": "Groupe 1513",
    transform: "translate(-198.47 1126.848) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1362",
    "data-name": "Groupe 1362",
    transform: "translate(1088.848 181.47)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_285",
    "data-name": "Ligne 285",
    x2: 8.587,
    y2: 8.581,
    transform: "translate(12.257 35.717)",
    fill: "none",
    stroke: "#ba9857",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_286",
    "data-name": "Ligne 286",
    x2: 9.187,
    y2: 8.581,
    transform: "translate(20.281 44.598) rotate(-90)",
    fill: "none",
    stroke: "#ba9857",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightchevron);
export default __webpack_public_path__ + "static/media/rightchevron.f41dac40496eb08be48cb3a12fbac849.svg";
export { ForwardRef as ReactComponent };